<template>
  <div class="container">
    <van-tabs @click="clickTag">
      <van-tab title-style="font-weight:bold;" :title='$t("investPage.productList")'>
        <div class="product-list">
          <div v-for="elem of data" :key="elem.id" class="product" @click="$router.push({ path: '/productDetails', query: { id: elem.id } })">
            <img :src="elem.productImage">
            <div>
              <span>USDT</span>
              <span>{{ $t("investPage.dailyRate") }} <span class="dark">{{elem.dailyInterestRate * 100}}%</span></span>
              <span>{{ $t("investPage.cycle") }}: <span class="dark">{{elem.cycle}}{{ $t("investPage.day") }}</span></span>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title-style="font-weight:bold;" :title='$t("common.deposit")'></van-tab>
      <van-tab title-style="font-weight:bold;" :title='$t("investPage.investedList")'>{{ $t("investPage.investedList") }}</van-tab>
    </van-tabs>
  </div>
</template>

<script>

export default {
  name: 'invest',
  data() {
    return {
      data: []
    }
  },
  mounted() {
        this.token = localStorage.getItem('token');
        this._fetch();
    },
    methods: {
      _fetch() {
          this.apiV1({
              method: 'get',
              url: '/financialProduct',
              headers: {'Authorization': this.token}
          }).then(response => {
              const { success, data } = response.data;
              if (success) {
                  this.data = data;
              }
          })
      },
      clickTag(index) {
        if (index === 1) {
          this.$router.push('/deposit');
        }
        if (index === 2) {
          this.$router.push('/investedList');
        }
      }
  }
}
</script>
<style scoped lang="less">
.product-list {
  padding: 4rem 4rem 20rem;
  .product {
    display: flex;
    padding: 2.933rem 3.2rem;
    border: 0.667rem solid @app-theme-color1;
    border-radius: 5.333rem;
    background-color: @app-theme-color4;
    margin-bottom: 4rem;
    img {
      width: 31.733rem;
      height: 21.067rem;
      border-radius: 2.4rem;
    }
    >div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 4.267rem;
      color: @app-theme-color3;
      // color: #808080;
      span.dark {
        color: @app-theme-color1;
        font-weight: bold;
      }
    }
  }
}
</style>
